import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface InviteState {
  open: boolean;
}

const initialState: InviteState = {
  open: false,
};

export const inviteSlice = createSlice({
  name: "invite",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
});

export const { setOpen } = inviteSlice.actions;

export default inviteSlice.reducer;
